import { Age, FormData, Phone } from '../store/types/patient';
import { IPD_ADMIT_PATIENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { Duration } from './ipdAdmitPatient';

export interface Response {
    success: boolean;
    data: Data[];
    error?: string;
}

export interface Data {
    id: string;
    ipid: string;
    pid: string;
    docid: string;
    doc: IdAndName;
    status: string;
    patient: Patient;
    date: string;
    bed?: string;
    department: IdAndName;
    insurance: Insurance;
    duration: Duration;
    totalBilled?: number;
    totalPaid?: number;
}

interface IdAndName {
    id?: string;
    name?: string;
}

export interface Patient {
    profile: Profile;
    id: string;
    uuid: string;
    poid: string;
    formData: FormData[];
}

interface Profile {
    personal: Personal;
}

interface Personal {
    age: Age;
    phone?: Phone;
    name: string;
    gender: string;
}

export interface Insurance {
    pre_approved_id: string;
    pre_approved_amount: number;
    pre_approved: boolean;
    number: string;
    type: string;
}

export default (): Promise<Response> => {
    return fetchWithRefresh(IPD_ADMIT_PATIENT).then((res) => res.json());
};
